import React, {DetailedHTMLProps, HTMLAttributes, ReactNode} from 'react';
import cn from "classnames";
import styles from './TitleUnderline.module.scss'

interface TitleUnderlineProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>{
    children: ReactNode
}

const TitleUnderline = ({children, className}: TitleUnderlineProps) => {
    return (
        <h2 className={cn(styles.title, className)}>
            {children}
        </h2>
    );
};

export default TitleUnderline;